import type { CleaningTaskQueueResponse } from '@/shared/api';
import { dayTitle } from '../CleaningDateNav';
import { todayInTimeZone } from '../calendar/cleaningCalendarHelpers';
import { arrivalShort, clockTime } from '../my-tasks/taskLabels';
import { useCleaningScope } from '../useCleaningScope';
import { workFacts } from './workModel';

function safeToday(timeZone: string | undefined): string {
  try {
    return todayInTimeZone(timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch {
    return todayInTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  }
}

/**
 * Zeit der Aufgabe in der Ortszeit ihres eigenen Objekts — nicht des gerade gewählten: ein
 * Direktlink oder ein anderes gewähltes Objekt ändert die Uhr nicht. Ist das Objekt nicht unter
 * den erlaubten, zeigt `clockTime` die Gerätezeit und sagt das.
 */
export function useTaskClock(task: CleaningTaskQueueResponse | undefined) {
  const { groups } = useCleaningScope();
  const timeZone = task
    ? groups.find((group) => group.apartments.some((a) => a.id === task.propertyId))?.timezone
    : undefined;
  if (!task) return { timeZone, facts: '' };
  const today = safeToday(timeZone);
  const day = task.scheduledFor === today ? null : dayTitle(task.scheduledFor, today);
  const startedAt =
    task.status === 'InProgress' && task.startedAt ? clockTime(task.startedAt, timeZone) : null;
  return {
    timeZone,
    facts: workFacts(task, { day, startedAt, arrival: arrivalShort(task, today) }),
  };
}
